// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-7e6ad2d8]{display:none}.container[data-v-7e6ad2d8]{display:flex;flex-direction:column;gap:8px}[data-v-7e6ad2d8] .container__note{border-radius:8px;color:var(--c-primary-800);line-height:20px;margin-top:12px;padding:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
